import { render, staticRenderFns } from "./PaymentInstructionPropertyList.vue?vue&type=template&id=23b068a3&scoped=true&"
import script from "./PaymentInstructionPropertyList.vue?vue&type=script&lang=ts&"
export * from "./PaymentInstructionPropertyList.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentInstructionPropertyList.vue?vue&type=style&index=0&id=23b068a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b068a3",
  null
  
)

export default component.exports